import { Divider, TextField, Box, Grid, Typography, Select, MenuItem, FormControlLabel } from "@mui/material";
import { useState, useEffect } from "react";
import AuthTypeText from "./AuthTypeText";
import { ExpandMore } from "@mui/icons-material";

const AWSAuthorization = ({ authorization, onAuthorizationUpdate }) => {
  const [authType, setAuthType] = useState(authorization?.authType);
  const [accessKey, setAccessKey] = useState(authorization?.accessKey);
  const [secretKey, setSecretKey] = useState(authorization?.secretKey);
  const [awsRegion, setAwsRegion] = useState(authorization.awsRegion);
  const [serviceName, setServiceName] = useState(authorization?.serviceName);
  const [sessionToken, setSessionToken] = useState(authorization?.sessionToken);

  const handleInputChange = (field, value) => {
    switch (field) {
      case 'authType':
        setAuthType(value);
        break;
      case 'accessKey':
        setAccessKey(value);
        break;
      case 'secretKey':
        setSecretKey(value);
        break;
      case 'awsRegion':
        setAwsRegion(value);
        break;
      case 'serviceName':
        setServiceName(value);
        break;
      default:
        setSessionToken(value);
    }
  };

  const handleApiCall = async () => {
    await onAuthorizationUpdate({
      authorization_value: {
        authType: authType,
        accessKey: accessKey,
        secretKey: secretKey,
        awsRegion: awsRegion,
        serviceName: serviceName,
        sessionToken: sessionToken
      }
    });
  };

  return (
    <Box p={2}>
      <AuthTypeText />
      <Divider sx={{ my: 2 }} />

      <Grid container spacing={2} alignItems="center">
        <Grid item xs={3}>
          <Typography variant="body">Add Auth data to:</Typography>
        </Grid>
        <Grid item xs={9}>
          <Select
            size="small"
            variant="outlined"
            value={authType}
            onChange={(e) => handleInputChange('authType', e.target.value)}
            style={{ width: '40%' }}
          >
            <MenuItem value={"Request Headers"}>Request Headers</MenuItem>
            <MenuItem value={"Request Url"}>Request Url</MenuItem>
          </Select>
        </Grid>

        <Grid item xs={3}>
          <Typography variant="body">Access Key:</Typography>
        </Grid>
        <Grid item xs={9}>
          <TextField
            size="small"
            variant="outlined"
            value={accessKey}
            onChange={(e) => handleInputChange('accessKey', e.target.value)}
            onBlur={handleApiCall}
            style={{ width: '40%' }}
          />
        </Grid>

        <Grid item xs={3}>
          <Typography variant="body">Secret Key:</Typography>
        </Grid>
        <Grid item xs={9}>
          <TextField
            size="small"
            variant="outlined"
            value={secretKey}
            onChange={(e) => handleInputChange('secretKey', e.target.value)}
            onBlur={handleApiCall}
            style={{ width: '40%' }}
          />
        </Grid>

        <Grid item xs={3}>
          <Typography variant="body">AWS Region:</Typography>
        </Grid>
        <Grid item xs={9}>
          <TextField
            size="small"
            variant="outlined"
            value={awsRegion}
            onChange={(e) => handleInputChange('awsRegion', e.target.value)}
            onBlur={handleApiCall}
            style={{ width: '40%' }}
          />
        </Grid>

        <Grid item xs={3}>
          <Typography variant="body">Service Name:</Typography>
        </Grid>
        <Grid item xs={9}>
          <TextField
            size="small"
            variant="outlined"
            value={serviceName}
            onChange={(e) => handleInputChange('serviceName', e.target.value)}
            onBlur={handleApiCall}
            style={{ width: '40%' }}
          />
        </Grid>

        <Grid item xs={3}>
          <Typography variant="body">Session Token:</Typography>
        </Grid>
        <Grid item xs={9}>
          <TextField
            size="small"
            variant="outlined"
            value={sessionToken}
            onChange={(e) => handleInputChange('sessionToken', e.target.value)}
            onBlur={handleApiCall}
            style={{ width: '40%' }}
          />
        </Grid>

        <Grid item xs={12}>
          <FormControlLabel
            control={<ExpandMore />}
            label={<Typography variant="body2" color="grey">ADVANCED</Typography>}
          />
          <Typography variant="body2" color="grey">
            These are advanced configuration options. They are optional. Qodex will auto generate values for some fields if left blank.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AWSAuthorization;
